import OtpVerificationComponent from "@Components/Pages/Common/OtpVerificationComponent";
import { apiUser } from "@Services/API/IndividualApi's/User";
import { useRouter } from "next/router";
import { useState } from "react";

interface verifyOtpProps {
  PhoneNo: string;
}
const VerifyOtp = ({ PhoneNo }: verifyOtpProps) => {
  const router = useRouter();
  const [spinner, setSpinner] = useState<boolean>(false);
  const [isOtpError, setIsOtpError] = useState<boolean>(false);

  const handleSubmit = async (OTP: any) => {
    setSpinner(true);
    const obj = {
      phoneNumber: PhoneNo,
      code: OTP,
    };

    const queryParam = `?kind=registration`;

    try {
      const response = await apiUser.verify(obj, queryParam);
      if (response) {
        setSpinner(false);
        setIsOtpError(false);
        router.back();
      }
    } catch (err) {
      setSpinner(false);
      setIsOtpError(true);
      console.log(err);
    }
  };

  const handleResendAnOtp = async () => {
    const obj = {
      phoneNumber: PhoneNo,
    };
    // const response = await LoginWithOtp.post!(obj)
    const response = await apiUser.loginWithOtp(obj);
  };

  return (
    <OtpVerificationComponent
      handleSubmit={handleSubmit}
      handleResendAnOtp={handleResendAnOtp}
      spinner={spinner}
      isOtpError={isOtpError}
    />
  );
};

export default VerifyOtp;
